/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventoryWallet model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventoryWallet {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventoryWallet</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventoryWallet</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventoryWallet</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventoryWallet();

            if (data.hasOwnProperty('balancePer')) {
                obj['balancePer'] = ApiClient.convertToType(data['balancePer'], 'Number');
            }
            if (data.hasOwnProperty('balanceXper')) {
                obj['balanceXper'] = ApiClient.convertToType(data['balanceXper'], 'Number');
            }
            if (data.hasOwnProperty('balanceHvh')) {
                obj['balanceHvh'] = ApiClient.convertToType(data['balanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('balanceUsdt')) {
                obj['balanceUsdt'] = ApiClient.convertToType(data['balanceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('balanceArb')) {
                obj['balanceArb'] = ApiClient.convertToType(data['balanceArb'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryWallet</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryWallet</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} balancePer
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.prototype['balancePer'] = undefined;

/**
 * @member {Number} balanceXper
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.prototype['balanceXper'] = undefined;

/**
 * @member {Number} balanceHvh
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.prototype['balanceHvh'] = undefined;

/**
 * @member {Number} balanceUsdt
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.prototype['balanceUsdt'] = undefined;

/**
 * @member {Number} balanceArb
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.prototype['balanceArb'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventoryWallet;

